import SearchBoxFilter from "../SearchBoxFilter/index";

export const BUTTON_LABELS = {
  CANCEL: "Cancel",
  UPDATE: "Update filters",
  GO_BACK: "Go back",
  ADD_FILTER: "Add filter",
  RESET: "Reset filters",
};

interface FilterProp {
  filterProps: {
    /**
     * setGlobalFilter callback method that emit changes to the parent admin table,
     * inherited from the angelou renderGlobalFilter prop.
     */
    setGlobalFilter: (filters: Record<string, any>) => void;
    /**
     * Admin table globalFilter values, represented as an object that includes
     * the search box filter and modal filter values applied to the admin table instance.
     */
    globalFilter: Record<string, any>;
  };
  filterUIProps: {
    searchFieldLabel: string;
    searchFieldPlaceholder: string;
  };

  filterDefinitions: Record<any, any>;
  readQuerySearch: boolean | undefined;
}

const Filter = ({
  filterProps,
  filterUIProps,
  readQuerySearch,
}: FilterProp) => {
  const { setGlobalFilter, globalFilter } = filterProps;
  const { searchFieldLabel, searchFieldPlaceholder } = filterUIProps;

  return (
    <SearchBoxFilter
      label={searchFieldLabel}
      placeholder={searchFieldPlaceholder}
      onChange={setGlobalFilter}
      globalFilter={globalFilter}
      readQuerySearch={!!readQuerySearch}
    />
  );
};

export default Filter;
